import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { lazy } from "react";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export interface IContactBrandModalProps {
  brand: Pick<
    IProductPageResponse.IPdpBrand,
    "name" | "owner_first_name" | "upper_bound_lead_time_days" | "token"
  >;
  collectionName?: string;
  productName?: string;
  closeContactMakerModal: () => void;
}

export const LazyContactBrandModal = lazy(() =>
  import(
    /* webpackChunkName: "retailer-contact-brand-modal" */ "./ContactBrandModal"
  )
    .then((m) => ({ default: m.ContactBrandModal }))
    .catch(handleComponentLoadError)
);
